import React from 'react';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { SOTT_DEFAULT_WEB_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { Button } from '../Button/styled';
import { StyledIcon as PlayerIcon } from '../Icons';
export var Type;
(function (Type) {
    Type[Type["Previous"] = 0] = "Previous";
    Type[Type["Next"] = 1] = "Next";
})(Type || (Type = {}));
export const PrevNextChannelButton = ({ epgData, type, backgroundColor, className, customIcon, styles, }) => {
    const router = useRouter();
    const onClickHandler = (event) => {
        if (event && event.stopPropagation)
            event.stopPropagation();
        const { channels } = epgData;
        const index = channels.findIndex(({ isCurrentlyPlaying }) => isCurrentlyPlaying);
        if (index === -1)
            return;
        const nextIndex = (index +
            (type === Type.Previous ? channels.length : 0) +
            (type === Type.Previous ? -1 : 1)) %
            channels.length;
        const { channel, currentProgram: asset } = channels[nextIndex];
        const { type: assetType, id } = asset;
        const assetLink = SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
            type: assetType,
            id,
        });
        router.replace({
            pathname: assetLink.href,
            query: { channelId: channel.id },
        }, assetLink.as);
    };
    const iconName = type === Type.Previous ? 'onDark-control_skipPrevious' : 'onDark-control_skipNext';
    return (React.createElement(Button, { style: styles.button, "data-test": "PrevNextChannelButton-Button", className: `${className} PrevNextChannelButton-Button`, onClick: onClickHandler, backgroundColor }, customIcon(iconName, backgroundColor, styles)));
};
const RenderDefaultIcon = (buttonIconName, backgroundColor, styles) => (React.createElement(PlayerIcon, { name: buttonIconName, style: styles.icon, "data-test": "PrevNextChannelButton-Icon", className: "PrevNextChannelButton-Icon", backgroundColor }));
PrevNextChannelButton.defaultProps = {
    className: '',
    backgroundColor: 'transparent',
    customIcon: RenderDefaultIcon,
    styles: {
        button: null,
        icon: null,
    },
};
//# sourceMappingURL=index.js.map